module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_anchor_arrow_gold-2084cdf12e5f6265166e37d568c03fe8.svg";